import paymentInstance from '../instance'

const getStripeAccount = () => {
	return paymentInstance.get('/stripeAccount')
}

export default getStripeAccount
